import config from './config.js';

const authConfig = {
  domain: config.domain,
  clientId: config.clientId,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: config.audience, // This is required for backend auth!
    scope: "openid profile email offline_access", // offline_access enables refresh tokens
  }
};

export default authConfig;
